import { render, staticRenderFns } from "./StandardTab.vue?vue&type=template&id=a508745a&"
import script from "./StandardTab.vue?vue&type=script&lang=js&"
export * from "./StandardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports